/**
 * Truncates the text to the given character limit.
 * This allows us to have multiple lines of text with ellipsis.
 *
 * @param {string} title - The book title
 * @param {number} charLimit - The character limit
 * @returns {string} A truncated string
 */
export const truncateText = (title, charLimit) => {
  if (title.length <= charLimit) {
    return title
  }

  return `${title.slice(0, charLimit)}...`
}
